export enum Countries {
  Afghanistan = 4,
  Albania = 8,
  Algeria = 12,
  AmericanSamoa = 16,
  Andorra = 20,
  Angola = 24,
  Anguilla = 660,
  Antarctica = 10,
  AntiguaAndBarbuda = 28,
  Argentina = 32,
  Armenia = 51,
  Aruba = 533,
  Australia = 36,
  Austria = 40,
  Azerbaijan = 31,
  Bahamas = 44,
  Bahrain = 48,
  Bangladesh = 50,
  Barbados = 52,
  Belarus = 112,
  Belgium = 56,
  Belize = 84,
  Benin = 204,
  Bermuda = 60,
  Bhutan = 64,
  Bolivia = 68,
  BonaireSintEustatiusAndSaba = 535,
  BosniaAndHerzegovina = 70,
  Botswana = 72,
  BouvetIsland = 74,
  Brazil = 76,
  BritishIndianOceanTerritory = 86,
  BruneiDarussalam = 96,
  Bulgaria = 100,
  BurkinaFaso = 854,
  Burundi = 108,
  CaboVerde = 132,
  Cambodia = 116,
  Cameroon = 120,
  Canada = 124,
  CaymanIslands = 136,
  CentralAfricanRepublic = 140,
  Chad = 148,
  Chile = 152,
  China = 156,
  ChristmasIsland = 162,
  CocosKeelingIslands = 166,
  Colombia = 170,
  Comoros = 174,
  Congo = 178,
  CongoDemocraticRepublic = 180,
  CookIslands = 184,
  CostaRica = 188,
  CoteDivoire = 384,
  Croatia = 191,
  Cuba = 192,
  Curacao = 531,
  Cyprus = 196,
  Czechia = 203,
  Denmark = 208,
  Djibouti = 262,
  Dominica = 212,
  DominicanRepublic = 214,
  Ecuador = 218,
  Egypt = 818,
  ElSalvador = 222,
  EquatorialGuinea = 226,
  Eritrea = 232,
  Estonia = 233,
  Eswatini = 748,
  Ethiopia = 231,
  FalklandIslands = 238,
  FaroeIslands = 234,
  Fiji = 242,
  Finland = 246,
  France = 250,
  FrenchGuiana = 254,
  FrenchPolynesia = 258,
  FrenchSouthernTerritories = 260,
  Gabon = 266,
  Gambia = 270,
  Georgia = 268,
  Germany = 276,
  Ghana = 288,
  Gibraltar = 292,
  Greece = 300,
  Greenland = 304,
  Grenada = 308,
  Guadeloupe = 312,
  Guam = 316,
  Guatemala = 320,
  Guernsey = 831,
  Guinea = 324,
  GuineaBissau = 624,
  Guyana = 328,
  Haiti = 332,
  HeardIslandAndMcDonaldIslands = 334,
  HolySee = 336,
  Honduras = 340,
  HongKong = 344,
  Hungary = 348,
  Iceland = 352,
  India = 356,
  Indonesia = 360,
  Iran = 364,
  Iraq = 368,
  Ireland = 372,
  IsleOfMan = 833,
  Israel = 376,
  Italy = 380,
  Jamaica = 388,
  Japan = 392,
  Jersey = 832,
  Jordan = 400,
  Kazakhstan = 398,
  Kenya = 404,
  Kiribati = 296,
  NorthKorea = 408,
  SouthKorea = 410,
  Kuwait = 414,
  Kyrgyzstan = 417,
  Laos = 418,
  Latvia = 428,
  Lebanon = 422,
  Lesotho = 426,
  Liberia = 430,
  Libya = 434,
  Liechtenstein = 438,
  Lithuania = 440,
  Luxembourg = 442,
  Macao = 446,
  Madagascar = 450,
  Malawi = 454,
  Malaysia = 458,
  Maldives = 462,
  Mali = 466,
  Malta = 470,
  MarshallIslands = 584,
  Martinique = 474,
  Mauritania = 478,
  Mauritius = 480,
  Mayotte = 175,
  Mexico = 484,
  Micronesia = 583,
  Moldova = 498,
  Monaco = 492,
  Mongolia = 496,
  Montenegro = 499,
  Montserrat = 500,
  Morocco = 504,
  Mozambique = 508,
  Myanmar = 104,
  Namibia = 516,
  Nauru = 520,
  Nepal = 524,
  Netherlands = 528,
  NewCaledonia = 540,
  NewZealand = 554,
  Nicaragua = 558,
  Niger = 562,
  Nigeria = 566,
  Niue = 570,
  NorfolkIsland = 574,
  NorthMacedonia = 807,
  NorthernMarianaIslands = 580,
  Norway = 578,
  Oman = 512,
  Pakistan = 586,
  Palau = 585,
  Palestine = 275,
  Panama = 591,
  PapuaNewGuinea = 598,
  Paraguay = 600,
  Peru = 604,
  Philippines = 608,
  Pitcairn = 612,
  Poland = 616,
  Portugal = 620,
  PuertoRico = 630,
  Qatar = 634,
  Reunion = 638,
  Romania = 642,
  Russia = 643,
  Rwanda = 646,
  SaintBarthelemy = 652,
  SaintHelena = 654,
  SaintKittsAndNevis = 659,
  SaintLucia = 662,
  SaintMartin = 663,
  SaintPierreAndMiquelon = 666,
  SaintVincentAndTheGrenadines = 670,
  Samoa = 882,
  SanMarino = 674,
  SaoTomeAndPrincipe = 678,
  SaudiArabia = 682,
  Senegal = 686,
  Serbia = 688,
  Seychelles = 690,
  SierraLeone = 694,
  Singapore = 702,
  SintMaarten = 534,
  Slovakia = 703,
  Slovenia = 705,
  SolomonIslands = 90,
  Somalia = 706,
  SouthAfrica = 710,
  SouthGeorgiaAndTheSouthSandwichIslands = 239,
  SouthSudan = 728,
  Spain = 724,
  SriLanka = 144,
  Sudan = 729,
  Suriname = 740,
  SvalbardAndJanMayen = 744,
  Sweden = 752,
  Switzerland = 756,
  Syria = 760,
  Taiwan = 158,
  Tajikistan = 762,
  Tanzania = 834,
  Thailand = 764,
  TimorLeste = 626,
  Togo = 768,
  Tokelau = 772,
  Tonga = 776,
  TrinidadAndTobago = 780,
  Tunisia = 788,
  Turkey = 792,
  Turkmenistan = 795,
  TurksAndCaicosIslands = 796,
  Tuvalu = 798,
  Uganda = 800,
  Ukraine = 804,
  UnitedArabEmirates = 784,
  UnitedKingdom = 826,
  UnitedStatesMinorOutlyingIslands = 581,
  UnitedStates = 840,
  Uruguay = 858,
  Uzbekistan = 860,
  Vanuatu = 548,
  Venezuela = 862,
  Vietnam = 704,
  BritishVirginIslands = 92,
  USVirginIslands = 850,
  WallisAndFutuna = 876,
  WesternSahara = 732,
  Yemen = 887,
  Zambia = 894,
  Zimbabwe = 716,
  AlandIslands = 248,
  Other = 999,
}

export default Countries; 